import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assets/linkdin_profile.png'
import HeaderSocials from './HeaderSocials'

export default function Header() {
  return (
    <header>
      <div className='container header_container'>
        <h5>Salut je suis</h5>
        <h1>SYLLA Mangué</h1>
        <h5 className='text-ight'>Fullstack Developper</h5>
        <p>
          Téléchargez mon CV pour avoir plus de détails sur mon parcours
          universitaire et expériences proffessionnelles !
        </p>
        <CTA></CTA>
        <HeaderSocials></HeaderSocials>
        <div className='me'>
          <img src={ME} alt='' />
        </div>
        <a href='#contact' className='scroll_down'>
          Scroll Down
        </a>
      </div>
    </header>
  )
}
